var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuMsgIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3940_86844)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8447 0H33.2738C15.1906 0 0.53125 14.6593 0.53125 32.7425V87.3135C0.53125 105.397 15.1906 120.056 33.2738 120.056H87.8447C105.928 120.056 120.587 105.397 120.587 87.3135V32.7425C120.587 14.6593 105.928 0 87.8447 0Z",
    fill: "#9C9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4678 28.8672C67.4838 28.8672 67.5156 28.8672 67.5634 28.8672C83.6831 28.8672 96.7924 41.9763 96.7924 58.0959C96.7924 64.6744 94.5464 71.0617 90.4369 76.2066L94.6898 86.0982C95.0402 86.9105 94.6579 87.8503 93.8615 88.1848C93.5748 88.3122 93.2562 88.3441 92.9536 88.2963L77.3595 85.5566C74.2375 86.6875 70.9562 87.2609 67.643 87.245C51.5233 87.245 38.4141 74.1359 38.4141 58.0163C38.3822 41.9444 51.3959 28.8831 67.4678 28.8672ZM77.471 52.2183H68.8695C67.9935 52.2183 67.2767 52.9351 67.2767 53.8112C67.2767 54.6872 67.9935 55.404 68.8695 55.404H77.471C78.3471 55.404 79.0638 54.6872 79.0638 53.8112C79.0638 52.9351 78.3471 52.2183 77.471 52.2183ZM57.7195 63.3682H77.471C78.3471 63.3682 79.0638 62.6515 79.0638 61.7754C79.0638 60.8993 78.3471 60.1825 77.471 60.1825H57.7195C56.8435 60.1825 56.1267 60.8993 56.1267 61.7754C56.1267 62.6515 56.8435 63.3682 57.7195 63.3682Z",
    fill: "#BABDBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0083 81.9541C63.9885 81.9541 72.0791 73.8635 72.0791 63.8833C72.0791 53.9031 63.9885 45.8125 54.0083 45.8125C44.0281 45.8125 35.9375 53.9031 35.9375 63.8833C35.9375 73.8635 44.0281 81.9541 54.0083 81.9541Z",
    fill: "#CED1D2"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3940_86844)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3940_86844",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 34,
    width: 60,
    height: 60
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7313 34.1562H24.2812V93.6064H83.7313V34.1562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3940_86844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1446 34.1562C54.1286 34.1562 54.0968 34.1562 54.049 34.1562C37.9294 34.1562 24.8203 47.2654 24.8203 63.3851C24.8203 69.9635 27.0662 76.3507 31.1757 81.4956L26.9228 91.3872C26.5724 92.1996 26.9547 93.1394 27.7511 93.4739C28.0378 93.6014 28.3564 93.6332 28.659 93.5854L44.253 90.8457C47.375 91.9767 50.6562 92.5501 53.9694 92.5342C70.089 92.5342 83.1981 79.425 83.1981 63.3054C83.23 47.2336 70.2164 34.1722 54.1446 34.1562ZM44.1415 57.5074H52.7429C53.6189 57.5074 54.3357 58.2242 54.3357 59.1003C54.3357 59.9764 53.6189 60.6931 52.7429 60.6931H44.1415C43.2654 60.6931 42.5486 59.9764 42.5486 59.1003C42.5486 58.2242 43.2654 57.5074 44.1415 57.5074ZM63.8928 68.6574H44.1415C43.2654 68.6574 42.5486 67.9405 42.5486 67.0644C42.5486 66.1884 43.2654 65.4717 44.1415 65.4717L54 65.5L63.8928 65.4717C64.7689 65.4717 65.4856 66.1884 65.4856 67.0644C65.4856 67.9405 64.7689 68.6574 63.8928 68.6574Z",
    fill: "#BABDBB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3940_86844",
    x: 20.8203,
    y: 31.1562,
    width: 66.375,
    height: 67.4492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3940_86844"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3940_86844",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3940_86844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuMsgIconInactive);
export default __webpack_public_path__ + "static/media/zunu_msg_icon_inactive.9b0cff1edf8a02c8dddfe5ce2e9f694e.svg";
export { ForwardRef as ReactComponent };